import React from 'react';
import styled from 'styled-components'
import Button from './button'
import PropTypes from 'prop-types';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog } from '@material-ui/core';

// <Modal
//   title="Are you sure this info is correct?"
//   message="Lorem ipsum dolor sit amet, tation scriptorem consequuntur mel ex, pri ex movet commune. Ius at explicari euripidis appellantur, ex vidisse voluptatibus eam, vix eu consul timeam aperiam."
//   submitLabel="Confirm"
//   open={modal1}
//   onClose={() => updateFirstModal(false)}
//   handleSubmit={handleSecondModal}
// >

const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: '8px',
    display: 'block',
    padding: '24px',
    margin: '16px',
  },
}));

const Title = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: ${props => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;
  width: 500px;
  @media(max-width: 900px) {
    width: auto;
  }
  svg {
    fill: ${props => props.theme.color.primary};
    height: auto;
    width: 36px;
    margin-right: 16px;
  }
`;

const Message = styled.p`
  color: #6f6f6f;
  font-size: 1rem;
  margin-bottom: 32px;
  @media(max-width: 900px) {
    font-size: 1rem;
    width: auto;
  }
`;

const Content = styled.div`
  margin-bottom: 32px;
  >p {
    color: #6f6f6f;
    font-size: 1rem;
    margin-bottom: 32px;
    @media(max-width: 900px) {
      font-size: 1rem;
      width: auto;
    }
  }
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  @media(max-width: 900px) {
    margin-top: 24px;
  }
`;

const CloseButton = styled(Button)`
  background: none;
  box-shadow: none;
  color: #888;
  margin: 0;
  // text-transform: uppercase;
  @media(max-width: 600px) {
    font-size: .875rem;
    height: 40px
  }

  &:hover {
    background: #EFEFEF;
  }

  &:active {
    background: #DDD;
    box-shadow: none;
    color: #555;
  }
`;

const AddButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
  // text-transform: uppercase;
  @media(max-width: 600px) {
    font-size: .875rem;
    height: 40px
  }
`;

const ModalComponent = (props) => {
  const classes = useStyles();
  
  return (
    <Dialog 
      classes={{ paper: classes.paper }} 
      open={props.open} 
      onClose={props.onClose}
      fullWidth={(!!props.maxWidth)}
      maxWidth={props.maxWidth}
    >
      <Title>
        {props.warning && <ErrorIcon />} {props.title}
      </Title>
      <Message>
        {props.message}
      </Message>
      <Content>
        {props.children}
      </Content>
      <ModalActions>
        <CloseButton
          onClick={props.onClose}
          label="Close"
        />
        {!(props.hideAction) &&
          <AddButton 
            disabled={props.disabled}
            label={props.submitLabel}
            onClick={props.handleSubmit}
            isLoading={props.isLoading}
          />
        }
      </ModalActions>
    </Dialog>
  )
}

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  submitLabel: PropTypes.string,
  handleSubmit: PropTypes.func,
};


export default ModalComponent
